export interface SurveyQuotaSupplier {
  currentTarget: number; // current_target
  completeNeeded: number; // complete_needed
}

export interface SurveyQuota {
  id: string; // buyer_quota_id
  psQuotaId: string; // ps_quota_id
  label: string; // quota_title || criteria condition names
  groupKey: string; // group_key
  locked: boolean; // locked
  fielded: number; // achieved
  goal: number; // current_target
  currentlyOpen: number; // currently_open
  maximum: number; // maximum
  allocationPercentage: number; // percentage
  hasInField: boolean; // in_field != null
  isUnknown: boolean; // isUnknown
  suppliers: SurveyQuotaSupplier[]; // supplier-level distribution
}

/**
 * The subset of a quota refreshed from the update-current-target API response.
 * Merged into the existing quota so grouping metadata (label/groupKey) is kept.
 */
export interface SurveyQuotaUpdate {
  psQuotaId: string;
  goal: number;
  currentlyOpen: number;
  maximum: number;
  allocationPercentage: number;
  fielded: number;
  locked: boolean;
  suppliers: SurveyQuotaSupplier[];
}

/** The user's choice in the pro-rata confirmation drawer. */
export type ProRataDecision = 'update-suppliers' | 'leave-as-is';

export const UNKNOWN_QUOTA_GROUP_KEY = 'Unknown';

export interface QuotaLockChange {
  psQuotaId: string;
  locked: boolean;
}

export interface QuotaCurrentTargetChange {
  psQuotaId: string;
  currentTarget: number;
}
